module.exports = __webpack_public_path__ + "static/img/application2-7.979ec52.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/application/application2-7.jpg
// module id = Px+g
// module chunks = 0